/**
 * OKjp 统一URL管理
 * @author yuxin.zhang
 */

// eslint-disable-next-line no-unused-vars
function getURL({ OKEX_BASE_URL2, MOCK_URL, BASE_URL, USER_CENTER_PATH }) {
  return {
    // 日本站独有 二步验证接口
    USER_LOGIN_STEP2: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/login/step2`,
    USER_WITHDRAW_SENDMSG: `${OKEX_BASE_URL2}/v2/asset/config/sendMsg`,
    USER_WITHDRAW_LIMIT: `${OKEX_BASE_URL2}/v2/asset/config/withdraw-limit`,
    GET_PARAMETER: `${OKEX_BASE_URL2}/v2/asset/cash/getParameter`,
    GET_EDD_KYC_INFO: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/edd/init-info`,
    POST_EDD_KYC_PERSONAL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/edd/save-person`,
    POST_EDD_KYC_COMPANY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/kyc/edd/save-company`,
    USER_REFERRAL_REWARD: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/reward`,
    USER_REFERRAL_HISTORY: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/reward/history`,
    USER_REGISTER_REFERRAL: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/register/referral-email`,
    USER_REGISTER_AFFILIATE: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/register/affiliate-email`,
    USER_REGISTER_PREPARATION: `${OKEX_BASE_URL2}${USER_CENTER_PATH}/register/affiliate-preparation`,
  };
}

export default getURL;
